enum OeeDefinition {
  Neither,
  Downtime,
  Runtime,
}
export default OeeDefinition;
